<!-- Car Makers Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">Car Makers Management</h3>
    </div>
    <div class="card-toolbar">
      <!-- Base Toolbar -->
      <div class="d-flex justify-content-end" data-kt-car-maker-table-toolbar="base">
        <!-- Save Changes Button -->
        <button
          *ngIf="hasChanges"
          type="button"
          class="btn btn-sm btn-success me-3"
          (click)="onSave()">
          <i class="ki-duotone ki-check fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Save Changes
        </button>

        <!-- Filter Button -->
        <button type="button" class="btn btn-sm btn-light-primary me-3" (click)="toggleFilters()">
          <i class="ki-duotone ki-filter fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Filter
        </button>

        <!-- Add Car Maker Button -->
        <button type="button" class="btn btn-sm btn-primary" (click)="openAddCarMakerModal()">
          <i class="ki-duotone ki-plus fs-2"></i>
          Add Car Maker
        </button>
      </div>

      <!-- Selected Toolbar -->
      <div class="d-flex justify-content-end align-items-center d-none" data-kt-car-maker-table-toolbar="selected">
        <div class="fw-bold me-5">
          <span data-kt-car-maker-table-select="selected_count">{{ selectedCarMakers.length }}</span> Selected
        </div>
        <button
          *ngIf="hasChanges"
          type="button"
          class="btn btn-success me-3"
          (click)="onSave()">
          <i class="ki-duotone ki-check fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Save Changes
        </button>
        <button type="button" class="btn btn-danger" (click)="deleteSelectedCarMakers()" data-kt-car-maker-table-select="delete_selected">
          Delete Selected
        </button>
      </div>
    </div>
  </div>

  <!-- Filter Section -->
  <div class="card-body border-bottom py-4" *ngIf="showFiltersForm" [@slideInOut]>
    <div class="row g-4">
      <div class="col-md-4">
        <label class="form-label fw-semibold text-gray-600 fs-7">Search Car Makers</label>
        <div class="d-flex align-items-center position-relative">
          <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-3">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <input
            type="text"
            class="form-control form-control-sm ps-10"
            placeholder="Search car makers..."
            [(ngModel)]="searchTerm"
            (keyup.enter)="applyFilters()"
          />
        </div>
      </div>
      <div class="col-md-8 d-flex align-items-end">
        <button type="button" class="btn btn-sm btn-primary me-2" (click)="applyFilters()">
          <i class="ki-duotone ki-magnifier fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Search
        </button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="resetFilters()">
          <i class="ki-duotone ki-cross fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Reset
        </button>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center py-10">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Data Table -->
    <div *ngIf="!isLoading" class="table-responsive">
      <table class="table align-middle table-row-dashed fs-6 gy-5" id="kt_car_makers_table">
        <thead>
          <tr class="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
            <th class="w-25px text-center">
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [checked]="isAllSelected()"
                  [indeterminate]="isIndeterminate()"
                  (change)="toggleAllSelection($event)">
              </div>
            </th>
            <th class="min-w-125px">Name</th>
            <th class="text-center min-w-100px">Show on Home</th>
            <th class="text-end min-w-100px">Actions</th>
          </tr>
        </thead>
        <tbody class="text-gray-600 fw-semibold">
          <tr *ngFor="let carMaker of carMakers; trackBy: trackByFn">
            <td class="text-center pe-0">
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [value]="carMaker._id"
                  [checked]="isSelected(carMaker._id)"
                  (change)="toggleSelection(carMaker._id, $event)">
              </div>
            </td>
            <td class="ps-2">
              <div class="d-flex align-items-center">
                <div class="d-flex justify-content-start flex-column">
                  <span class="text-dark fw-bold text-hover-primary fs-6">{{ carMaker.name || 'N/A' }}</span>
                </div>
              </div>
            </td>
            <td class="text-center">
              <div class="form-check form-check-custom form-check-solid d-flex justify-content-center">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [ngModel]="getFormValue(carMaker._id, 'show_on_home')"
                  (ngModelChange)="setFormValue(carMaker._id, 'show_on_home', $event)" />
              </div>
            </td>
            <td class="text-end">
              <div class="d-flex justify-content-end gap-2">
                <!-- Edit Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-primary"
                  (click)="openEditModal(carMaker)"
                  title="Edit Car Maker">
                  <i class="ki-duotone ki-pencil fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Delete Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-danger"
                  (click)="deleteCarMaker(carMaker)"
                  title="Delete Car Maker">
                  <i class="ki-duotone ki-trash fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                </button>
              </div>
            </td>
          </tr>
          <!-- Empty State -->
          <tr *ngIf="carMakers.length === 0">
            <td colspan="4" class="text-center py-10">
              <div class="d-flex flex-column align-items-center">
                <i class="ki-duotone ki-file-deleted fs-3x text-muted mb-4">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                <span class="text-muted fs-6">No car makers found</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div *ngIf="!isLoading && carMakers.length > 0">
      <app-pagination
        [paginationInfo]="paginationInfo"
        [loading]="isLoading"
        (pageChange)="onPageChange($event)">
      </app-pagination>
    </div>
  </div>
</div>

<!-- Car Maker Add/Edit Modal -->
<app-add-edit-car-makers
  (carMakerAdded)="onCarMakerAdded()"
  (carMakerUpdated)="onCarMakerUpdated()">
</app-add-edit-car-makers>
